import { getRouteApi, useLocation } from '@tanstack/react-router'
import Bowser from 'bowser'
import { useEffect, useState } from 'react'
import { routes } from '@/routing/routes'
import FallbackPage from './components/FallbackPage'
import { deeplinkConfigs } from './DeeplinkValidation.constants'

const interpolate = (template: string, key: string, value: string): string =>
  template.replace(`{${key}}`, value)

const bowser = Bowser.getParser(window.navigator.userAgent)
const { useSearch, useParams, useNavigate } = getRouteApi(
  routes.DeeplinkValidation.id
)

const DeeplinkValidation = () => {
  const location = useLocation()
  const { product, protocol } = useParams()
  const { data } = useSearch()
  const navigate = useNavigate()

  const [intentUrl, setIntentUrl] = useState<string>('')
  const [deeplinkFallbackUrl, setDeeplinkFallbackUrl] = useState<string>('')
  const [deeplinkUrl, setDeeplinkUrl] = useState<string>('')

  const triggerIntent = (url: string) => {
    const element = document.createElement('a')
    element.href = url
    element.click()
  }

  useEffect(() => {
    const deeplinkConfig = deeplinkConfigs.get(`${product}/${protocol}`)

    if (!deeplinkConfig) {
      navigate(routes.InvalidLinkError)
      return
    }

    setIntentUrl(interpolate(deeplinkConfig.intentUrl, 'tokenData', data))

    if (
      bowser.getOSName(true) === 'android' &&
      JSON.parse(myESET.envData.AutorunIntent)
    ) {
      triggerIntent(intentUrl)
    }

    setDeeplinkUrl(
      `https://${myESET.envData.DeeplinkHost}${location.pathname}${location.searchStr}`
    )

    setDeeplinkFallbackUrl(
      interpolate(
        deeplinkConfig.deeplinkFallbackUrl,
        'deeplink',
        // The deeplink URI is encoded twice since it's nested 2 levels deep inside the fallback URL query params
        encodeURIComponent(encodeURIComponent(deeplinkUrl))
      )
    )
  }, [product, protocol, intentUrl, deeplinkFallbackUrl, deeplinkUrl])

  return (
    <FallbackPage
      deeplinkFallbackUrl={deeplinkFallbackUrl}
      deeplinkUrl={deeplinkUrl}
      product={product}
    />
  )
}

export default DeeplinkValidation
